import { Navigate, useParams } from 'react-router-dom';

export default function ClientMessagingRedirectPage() {
  const { id } = useParams();
  if (id) {
    return <Navigate to={`/client/messaging/inbox/${id}`} />;
  }
  return <Navigate to={'/client/messaging/inbox'} />;
}
